"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableLayout = void 0;
var _UnexpectedError = require("../../components/unexpected-error/UnexpectedError");
var _LoadingBlock = require("../../elements/loading-block/LoadingBlock");
var _react = _interopRequireDefault(require("react"));
var _tableLayoutModule = _interopRequireDefault(require("./table-layout.module.scss"));
var TableLayout = function TableLayout(_ref) {
  var header = _ref.header,
    description = _ref.description,
    _ref$hasUnexpectedErr = _ref.hasUnexpectedError,
    hasUnexpectedError = _ref$hasUnexpectedErr === void 0 ? false : _ref$hasUnexpectedErr,
    newEntryButton = _ref.newEntryButton,
    _ref$filtersLoading = _ref.filtersLoading,
    filtersLoading = _ref$filtersLoading === void 0 ? false : _ref$filtersLoading,
    filters = _ref.filters,
    actions = _ref.actions,
    tableControls = _ref.tableControls,
    additionalFilters = _ref.additionalFilters,
    tableWithNavigation = _ref.tableWithNavigation,
    tabs = _ref.tabs;
  if (hasUnexpectedError) {
    return /*#__PURE__*/_react.default.createElement(_UnexpectedError.UnexpectedError, null);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _tableLayoutModule.default['table-layout']
  }, header && /*#__PURE__*/_react.default.createElement("div", {
    className: _tableLayoutModule.default['table-layout__header']
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h1", {
    className: _tableLayoutModule.default['table-layout__title']
  }, header), description && /*#__PURE__*/_react.default.createElement("div", {
    className: _tableLayoutModule.default['table-layout__description']
  }, description)), /*#__PURE__*/_react.default.createElement("div", {
    className: _tableLayoutModule.default['table-layout__new-entry-button']
  }, newEntryButton)), newEntryButton && !header && /*#__PURE__*/_react.default.createElement("div", {
    className: _tableLayoutModule.default['table-layout__header']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _tableLayoutModule.default['table-layout__new-entry-button']
  }, newEntryButton)), tabs && /*#__PURE__*/_react.default.createElement("div", {
    className: _tableLayoutModule.default['table-layout__tabs']
  }, tabs), (filters || actions || tableControls) && /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "toolbar-container",
    className: _tableLayoutModule.default['table-layout__toolbar']
  }, filtersLoading && (filters || actions) ? /*#__PURE__*/_react.default.createElement(_LoadingBlock.LoadingBlock, {
    className: _tableLayoutModule.default['table-layout__loading-filters'],
    "data-testid": "loading-filters"
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _tableLayoutModule.default['table-layout__filters']
  }, filters), /*#__PURE__*/_react.default.createElement("div", {
    className: _tableLayoutModule.default['table-layout__actions']
  }, actions)), /*#__PURE__*/_react.default.createElement("div", {
    className: _tableLayoutModule.default['table-layout__table-controls']
  }, tableControls)), additionalFilters, tableWithNavigation);
};
exports.TableLayout = TableLayout;